import axios from 'axios';
import { API_URL } from '../ApiConfig';

export const AtiveUser = async (costumerData) => {
  try {
    const response = await axios.post(`${API_URL}/AtiveUser`, costumerData);
    return response.data; // Certifique-se de que o backend retorna um objeto com 'success' e 'message'
  } catch (error) {
    console.error('Erro ao alterar cliente:', error.response?.data || error.message);
    return { success: false, message: 'Erro ao alterar cliente' };
  }
};
